__turbopack_context__.v({
  "center": "NKyFua_center",
  "deliverySlotsWrapper": "NKyFua_deliverySlotsWrapper",
});
